(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["j-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialize = (root) => {
      root.querySelectorAll('.j-chero__video').forEach((video) => {
        if (video.dataset.ready) return;
        video.dataset.ready = 'true';
        video.muted = true;
        if (!motion.matches) video.play().catch(() => {});
        motion.addEventListener('change', (event) => {
          if (event.matches) video.pause();
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-launch-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = 'mw-outfit-introduction-dismissed-v1';
    function initialize(root = document) {
      root.querySelectorAll('[data-mw-launch]').forEach(banner => {
        if (banner.dataset.initialized) return;
        banner.dataset.initialized = 'true';
        let timer;
        const cta = banner.querySelector('.mw-launch__cta');
        const close = banner.querySelector('.mw-launch__close');
        const dismiss = () => {
          banner.hidden = true;
          clearTimeout(timer);
          try { sessionStorage.setItem(key, '1'); } catch (_) {}
        };
        close.addEventListener('click', dismiss);
        cta.addEventListener('click', () => {
          dismiss();
          const target = document.getElementById('mousseweared');
          if (target) {
            target.setAttribute('tabindex', '-1');
            target.focus({preventScroll: true});
          }
        });
        banner.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            const destination = document.querySelector('.j-hero__cta .j-btn--ghost');
            dismiss();
            destination?.focus({preventScroll: true});
          }
        });
        const schedule = () => {
          try { if (sessionStorage.getItem(key)) return; } catch (_) {}
          timer = setTimeout(() => {
            if (!document.getElementById('mousseweared')) return;
            document.body.appendChild(banner);
            banner.hidden = false;
          }, Number(banner.dataset.delay) || 3000);
        };
        if (document.readyState === 'complete') schedule();
        else window.addEventListener('load', schedule, {once: true});
        document.addEventListener('shopify:section:unload', event => {
          if (event.detail.sectionId === banner.dataset.sectionId) {
            clearTimeout(timer);
            banner.remove();
          }
        });
      });
    }
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
